import { createStyles } from '@mantine/core';

const useEventCalendarAgendaStyles = createStyles(theme => ({
  agendaContent: {
    padding: `${theme.spacing.xl} calc(${theme.spacing.xl} * 2) calc(${theme.spacing.xl} * 2)`,
    gap: 0,
    [theme.fn.smallerThan('sm')]: {
      padding: theme.spacing.xs,
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 2fr',
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: '3fr 3fr 1fr 1fr',
      gridTemplateAreas: `
        "firstColumn name name name"
        "coach location middleColumn lastColumn"
      `,
      marginBottom: theme.spacing.lg,
    },
  },
  header: {
    paddingBottom: theme.fontSizes.xs,
    textAlign: 'left',
    gap: 0,
  },
  agendaItem: {
    height: `calc(${theme.spacing.lg} * 2)`,
    cursor: 'pointer',
    borderRadius: `calc(${theme.fontSizes.xs} / 2) !important`,
  },
  shadow: {
    boxShadow: `calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 5) calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 5) rgba(0, 0, 0, 0.1)`,
    border: 0,
  },
  name: {
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'name',
      width: '100%',
      borderRadius: `0px calc(${theme.fontSizes.xs} / 2)  0px 0px !important`,
    },
  },
  firstColumn: {
    paddingLeft: theme.spacing.sm,
    borderRadius: `calc(${theme.fontSizes.xs} / 2) 0px 0px calc(${theme.fontSizes.xs} / 2) !important`,
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'firstColumn',
      borderRadius: `calc(${theme.fontSizes.xs} / 2) 0px 0px 0px !important`,
    },
  },
  coach: {
    background: 'white',
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'coach',
      paddingLeft: theme.spacing.sm,
      borderRadius: `0px 0px 0px calc(${theme.fontSizes.xs} / 2) !important`,
    },
  },
  location: {
    background: 'white',
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'location',
    },
  },
  middleColumn: {
    background: 'white',
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'middleColumn',
    },
  },
  lastColumn: {
    background: 'white',
    borderRadius: `0px calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 2) 0px !important`,
    [theme.fn.smallerThan('sm')]: {
      gridArea: 'lastColumn',
    },
  },
  calendar: {
    fontFamily: `${theme.fontFamily} !important`,
  },
}));

export default useEventCalendarAgendaStyles;
